/**
 * Validate maximum amount of UTM.
 */
export const validateMaximumAmountUtm = ({ currency = 'CLP', amount = 0, utmToClpAmount = 0, exchangeRates }) => {
  if (currency === 'CLP') {
    return parseInt(amount, 10) <= utmToClpAmount
  }

  const typeCurrencyToClpAmount =
    parseInt(exchangeRates?.find(exchangeRate => exchangeRate.value === currency)?.clpAmount) * parseFloat(amount)
  return parseInt(typeCurrencyToClpAmount, 10) <= utmToClpAmount
}
